





























































































































































































































































































import CampoDeItemDeVenda from '@/components/venda/CampoDeItemDeVenda.vue'
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { DataOptions } from 'vuetify'
import { FindLojaUseCase, FindProdutoUseCase, FindVendaUseCase, NotasEmTransitoUseCase } from '@/usecases'
import { ItemDeRomaneio } from '@/models/Romaneio'
import { obrigatorio } from '@/shareds/regras-de-form'
import { displayVariantes, converterProdutoParaProdutoSimples, displayNomeCompletoDoProduto } from '@/shareds/produto-shareds'
import { 	 
	ItemDaVenda, 
	ResumoDaVenda,		
	ItemDaNotaEmTransito,	 
} from '@/models'
import type { Loja, NotaEmTransito } from '@/models'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'

@Component({
	components:{
		CampoDeItemDeVenda,
	},
})
export default class DialogoDeConferenciaDeEntradaDeMercadoria extends Vue {
	@Ref() form!: HTMLFormElement		
	@Prop({ type: Object }) loja!: Loja		
	@Prop({ required: false }) nota!: NotaEmTransito	
	@Prop({ required: false }) chaveInserida!: string
	@Prop({ default: false }) isConferenciaRfid!: boolean
	dialogoDeletarAberto = false;
	itemSelecionado: any = null;
	movimentarEstoque: boolean | null = null;
	movimentarEstoqueErro = '';

	notasEmTransitoUseCase = new NotasEmTransitoUseCase()
	findLojaUseCase = new FindLojaUseCase()
	
	eansDoPedido: string[] = []
	vendas: ResumoDaVenda[] = []	
	listaProdutosVerificados: string[] = []
	itemDaNotaEmTransito: ItemDaNotaEmTransito | null = null	
	
	notaEmTransito: NotaEmTransito | null = null
	chave: string | null = null

	recebendoNota = false
	mostra = false
	loading = false
	buscando = false	
	showCamera = false
	dialogoAberto = false
	buscandoProduto = false				
	carregandoCardDeVerificacao = false
	mostrarDialogoLeituraDeCodigoBarras = false	
	
	findVendaUseCase = new FindVendaUseCase()
	findProdutoUseCase = new FindProdutoUseCase()
	produtosBipados: Map<string, number> = new Map()	

	obrigatorio = obrigatorio	
	displayVariantes = displayVariantes
	dateTimeToPtBrFormat = dateTimeToPtBrFormat
	
	serverError: any = null
	valorLido: string | null = null			

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	readerSize = {
		width: 860,
		height: 480,
	}

	abrirDialogoDeletarMotivo(item: any) {
		this.itemSelecionado = item;
		this.dialogoDeletarAberto = true;
	}
	
	fecharDialogoDeletarMotivo() {
		this.dialogoDeletarAberto = false;
		this.itemSelecionado = null;
	}
	
	confirmarDeletarMotivo() {
		if (this.itemSelecionado) {			
			this.deleteMotivo(this.itemSelecionado);
		}
		this.fecharDialogoDeletarMotivo();
	}

	mostrar() {		
		this.mostra = true		
	}	

	async buscarLoja(){
		try {
			this.carregandoCardDeVerificacao = true
			if (!this.nota?.lojaId) {
				AlertModule.setError("ID da loja não encontrado na nota")
				return
			}
			this.loja = await this.findLojaUseCase.findLojaById(this.nota.lojaId)
		} catch (error: any) {
			AlertModule.setError("Erro ao buscar informações da loja")
			this.esconder()
		} finally {
			this.carregandoCardDeVerificacao = false
		}
	}
	
	abrirDialogoConfirmacao() {
		this.dialogoAberto = true
		this.movimentarEstoque = null
		this.movimentarEstoqueErro = ''
	}

	fecharDialogoConfirmacao() {
		this.dialogoAberto = false
	}

	esconder() {
		this.mostra = false
		this.chave = null		
		this.itemDaNotaEmTransito = null
		this.listaProdutosVerificados = []
		this.eansDoPedido = []
		this.produtosBipados.clear()
		this.produtosBipados.clear()				
		this.produtosBipados.clear()				
		this.chaveInserida = ''
		
	}		

	get itensAhVerificar() {
		if (!this.itemDaNotaEmTransito) return []		
		return Array.isArray(this.itemDaNotaEmTransito)
			? this.itemDaNotaEmTransito.map(item => ({
				...item,
				motivoSalvo: !!item.motivoFaltante?.trim(), 
			}))
			: [{ ...this.itemDaNotaEmTransito, motivoSalvo: !!this.itemDaNotaEmTransito.motivoFaltante?.trim() }]
	}

	get chaveDanfe() {
		return this.chave = this.chaveInserida ? this.chaveInserida : 'NFe' + this.nota.chaveDanfe
	}

	isProdutoVerificado(item: ItemDaNotaEmTransito) {
		return item.quantidadeBipada >= item.quantidade
	}

	isProdutoVerificacaoIncompleta(item: ItemDaNotaEmTransito) {
		return item.quantidadeBipada > 0 && item.quantidadeBipada < item.quantidade && (!item.motivoFaltante || item.motivoFaltante.trim() === "")
	}

	beep() {
		const audio = document.querySelector('audio')
		if(!audio) return 
		audio.play()
	}	

	get podeReceberNota() {
		if (!this.itensAhVerificar?.length) return false

		const exigeConferencia =
			this.loja?.configuracaoDaLoja?.exigeConferenciaCompletaNaImportacaoDeNotasEmTransito

		if (exigeConferencia === undefined) return false

		return this.itensAhVerificar.every(item =>
			exigeConferencia
				? this.isProdutoVerificado(item)
				: this.isProdutoVerificado(item) || item.motivoFaltante,
		)
	}

	async buscaItensDaNota(chaveDanfe: string) {
		try {			
			this.carregandoCardDeVerificacao = true	
			this.buscarLoja()

			if (!chaveDanfe) return

			try {
				const notaEncontrada = await this.notasEmTransitoUseCase.findByChaveDanfe(chaveDanfe)

				if (notaEncontrada.status === 'Recebido') {
					AlertModule.setError("A nota em transito já foi recebida!")
					setTimeout(() => {this.esconder()}, 3000)
					return
				}
				this.notaEmTransito = notaEncontrada
			} catch (e) {
				AlertModule.setError("Erro ao buscar nota.")
				console.error(e)
			}	

			try {					
				const itens = await this.notasEmTransitoUseCase.getProdutosDaNotaEmTransito(chaveDanfe)			
				this.itemDaNotaEmTransito = itens				
			} catch (e) {
				AlertModule.setError("Erro ao buscar produtos da nota.")
				console.error(e)
			}

			if (this.isConferenciaRfid){
				try {
					await this.notasEmTransitoUseCase.salvarProdutosBipadosNoRfid(chaveDanfe)
					const itensAtualizados = await this.notasEmTransitoUseCase.getProdutosDaNotaEmTransito(chaveDanfe)
					this.itemDaNotaEmTransito = itensAtualizados
				} catch(e) {
					AlertModule.setError("Erro ao buscar produtos conferidos via RFID.")
				}
			}
			
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregandoCardDeVerificacao = false			
		}		
	}	

	async logIt(data: any) {
		this.showCamera = false
		this.buscandoProduto = true
		this.beep()
		this.valorLido = data.codeResult.code

		if (this.valorLido && this.loja.id) {
			try {
				const produto = await this.findProdutoUseCase.findProdutoComEstoque(
					this.valorLido,
					this.loja.id,
				)

				if(!produto) {
					AlertModule.setError("Produto não encontrado na nota!")
				} 

				const item: ItemDaVenda = {
					id: '',
					produto: converterProdutoParaProdutoSimples(produto),
					quantidade: 0,
					desconto: { isPercentual: true, valor: 0.0 },
					preco: produto.preco || 0,
					precoDeCusto: 0,
					idConjunto: null,
					descontoVarejo: 0,
					percentualCashback: 0,
					diasParaEfetivarCashback: 0,
					isBrinde: false,
					idItemNotaOrigem: null,
					chaveNotaOrigem: null,
					diasParaExpirarCashback: 0,
					possuiDescontoPorTabela: false,
					valorDescontoRateadoDoItem: 0,
					itemDeDevolucao: false,
					isTotalmenteTrocado: false,
					motivoCancelamento: null,
					isCompra: false,
					idItemOrigem: '',
					isDaVendaReaberta: false,
					vendedor: null,
					autenticadoParaLiberarProdutoSemEstoque: false,
					vendaOrigemDoItem: null,
					valorFreteRateado: 0,
					isItemReferenteATroca: false,
					quantidadeLida: 0,
					isDeOutraLoja: false,
					percentualDescontoTabelaPreco: 0,
					precoDeCustoReal: 0,
				}

				if(!this.eansDoPedido.includes(this.valorLido)) {
					AlertModule.setError("Produto não encontrado na nota!")
				} 

				if(this.eansDoPedido.includes(this.valorLido)) {
					AlertModule.setSuccess("Produto encontrado na nota!")
				}

				this.incluirItensNaTabela(item)
			} catch (error: any) {
				AlertModule.setError(error)
			} finally {
				this.buscandoProduto = false
				this.showCamera = true
			}
		}
	}		

	async incluirItensNaTabela(item: ItemDaVenda) {
		this.loading = true			

		try {
			const itemBipado: ItemDeRomaneio = {
				id: '',
				produto: {
					id: item.produto.id,
					nome: displayNomeCompletoDoProduto(item.produto),
					tipo: item.produto.tipo,
					preco: item.produto.preco,
					eans: item.produto.eans,
					sku: item.produto.sku || '',
					identificadores: item.produto.identificadores,
					nomeCompleto: item.produto.nomeCompleto,
					produtoDesativado: item.produto.produtoDesativado,
					descontoVarejo: item.produto.descontoVarejo,
					pesoBruto: item.produto.pesoBruto,
					pesoLiquido: item.produto.pesoLiquido,
					isValePresente: item.produto.isValePresente,
					urlImagens: item.produto.urlImagens,
					skuPai: item.produto.skuPai,
					estacao: item.produto.estacao,
					marca: null,
					categoria:null,
					genero: null,
					fornecedor: null,
				},
				quantidade: 1,
				dataHoraCriacao: new Date(),
			}

			const produtoLidoPeloCodigo = itemBipado.produto.id
			let itemEncontrado = false

			for (const itens of this.itensAhVerificar) {
				this.eansDoPedido.push(itens.id)

				if (produtoLidoPeloCodigo === itens.id) {
					itemEncontrado = true					

					if (itens.quantidadeBipada >= itens.quantidade) {
						AlertModule.setError(`Produto ${itens.nome} completamente verificado!`)
						return
					}

					this.salvarProdutoBipado(itens)
				}
			}

			if (!itemEncontrado) {				
				AlertModule.setError("Item não encontrado na nota")
			}

			const todosProdutosVerificadosPresentes = this.itensAhVerificar.every(item =>
				this.listaProdutosVerificados.includes(item.id),
			)

			if (todosProdutosVerificadosPresentes) {
				this.showCamera = false
				this.mostrarDialogoLeituraDeCodigoBarras = false
			}

		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.loading = false
		}
	}

	async salvarProdutoBipado(itemBipado: ItemDaNotaEmTransito) {
		if (!itemBipado) return

		try {
			this.loading = true

			const item: any = {				
				produtoId: itemBipado.id,			
				quantidadeBipada: itemBipado.motivoFaltante?.trim() ? 0 : 1,
				motivoFaltante: itemBipado.motivoFaltante?.trim() || null,
				notaEmTransito: { id: this.notaEmTransito?.id },
			}
			
			await this.notasEmTransitoUseCase.salvarProdutoBipadoDaNota(item)			

			if (!itemBipado.motivoFaltante) {
				AlertModule.setSuccess(`Produto ${itemBipado.nome} salvo com sucesso!`)
			} else if (itemBipado.motivoSalvo || itemBipado.quantidadeBipada >= itemBipado.quantidade) {
				AlertModule.setError('Item já verificado!')
			} else {
				AlertModule.setSuccess('Motivo salvo com sucesso!')
			}
			
			itemBipado.motivoSalvo = !!itemBipado.motivoFaltante?.trim()
		
			this.buscaItensDaNota(this.chaveDanfe)
		} catch (error: any) {
			const mensagemErro = error?.message || 'Ocorreu um erro ao salvar o produto.'
			AlertModule.setError(mensagemErro)
		} finally {
			this.loading = false
		}
	}

	async salvarMotivoProdutoFaltante(itemBipado: ItemDaNotaEmTransito) {

		if(itemBipado.motivoFaltante === '' || itemBipado.motivoFaltante === null) {
			AlertModule.setError("Não é possível salvar o produto como bipado quando há um motivo de falta.")
			return
		}

		try {
			this.loading = true

			const item: any = {				
				produtoId: itemBipado.id,			
				quantidadeBipada: 0,
				motivoFaltante: itemBipado.motivoFaltante?.trim(),
				notaEmTransito: { id: this.notaEmTransito?.id },
			}

			await this.notasEmTransitoUseCase.salvarMotivoProdutoFaltante(item)

			this.buscaItensDaNota(this.chaveDanfe)

			AlertModule.setSuccess("Motivo salvo com sucesso!")

		}  catch (error: any) {
			const mensagemErro = error?.message || 'Ocorreu um erro ao salvar o produto.'
			AlertModule.setError(mensagemErro)
		} finally {
			this.loading = false
		}
	}

	async deleteMotivo(itemBipado: ItemDaNotaEmTransito) {
		try {

			this.loading = true

			const item: any = {				
				produtoId: itemBipado.id,			
				quantidadeBipada: 0,
				motivoFaltante: null,
				notaEmTransito: { id: this.notaEmTransito?.id },
			}

			await this.notasEmTransitoUseCase.deleteMotivoFaltante(item)

			this.buscaItensDaNota(this.chaveDanfe)

			AlertModule.setSuccess("Motivo deletado com sucesso!")

		}  catch (error: any) {
			const mensagemErro = error?.message || 'Ocorreu um erro ao salvar o produto.'
			AlertModule.setError(mensagemErro)
		} finally {
			this.loading = false
		}
	}
	
	async resetarBipagem() {
		try {
			this.loading = true

			if (this.notaEmTransito?.id) {
				await this.notasEmTransitoUseCase.resetarBipagem(this.notaEmTransito.id, this.isConferenciaRfid)
			} else {
				AlertModule.setError("Nota não encontrada.")
			}		
			
			this.produtosBipados = new Map()

			console.log('teste', this.chaveDanfe)
			await this.buscaItensDaNota(this.chaveDanfe)
		} catch (e) {
			AlertModule.setError("Erro ao resetar produtos.")
			console.error(e)
		} finally {
			this.loading = false
		}
	}	

	async receberNota() {
		this.recebendoNota = true

		if(!this.usuario){
			AlertModule.setError('Não foi possivel capturar informações sobre o usuario')
			return
		}

		this.fecharDialogoConfirmacao()
		if (!this.notaEmTransito) {
			AlertModule.setError('nota em trânsito inválida')
			return
		}

		this.notaEmTransito.usuarioId = this.usuario.id

		if (this.movimentarEstoque === null) {
			this.movimentarEstoqueErro = 'Selecione se deseja movimentar o estoque.'
			this.recebendoNota = false
			this.dialogoAberto = true
			return
		} else {
			this.movimentarEstoqueErro = ''
		}

		switch (this.notaEmTransito?.status) {
			case 'Processando':
				AlertModule.setError('A nota já está em fase de processamento')
				return
			case 'Recebido':
				AlertModule.setError(
					'A nota já foi recebida no sistema e não é possível realizar um segundo recebimento',
				)
				return
		}
		
		try {
			
			await this.notasEmTransitoUseCase.receberNotaEmTransito(this.notaEmTransito, this.movimentarEstoque)
			
			AlertModule.setInfo(
				'A nota está sendo processada e você será notificado assim que o processo for concluído',
			)
			this.$emit('atualizarNotas', true)
		} catch (error: any) {
			AlertModule.setError(error)
			this.recebendoNota = false
			this.dialogoAberto = false
			this.esconder()
		} finally {
			this.recebendoNota = false
			this.esconder()
		}
	}	

	@Watch('mostra')
	onChangeMostra(){
		if (this.mostra) {
			this.buscaItensDaNota(this.chaveDanfe)
		}
	}	

	@Watch('movimentarEstoque')
	onMovimentarEstoqueChange(val: boolean | null) {
		if (val !== null) {
			this.movimentarEstoqueErro = ''
		}
	}

	movimentarEstoqueObrigatorio = (value: boolean | null) => {
		if (value === null) {
			return 'Selecione se deseja movimentar o estoque.'
		}
		return true
	}

	get usuario() {
		return UserLoginStore.usuario
	}
}
